<template src="./index.html">
</template>

<script>
	import {getdata} from "./data.js";
	import uploadFile from '../../../common/uploadFile/index.vue'
	export default {
		components:{
			uploadFile
		},
		data() {
			return {
				searchdata:getdata().searchdata,
				searchlist:getdata().searchlist,
				shaidiag:false,
				headData:getdata().headData,
				tableData:getdata().tableData,
				updataItem:{},
				pagination:getdata().pagination,
				outlist:[],
				options:[],
				upformdata:null,
				tablekey:0,
				overlength:0,
				filediag:false,
				title9:'合计',
				title8:'六、油气开发投资(合计)',
				title7:'五、油气勘探投资(合计)',
				title6:'四、长期待摊费用(合计)',
				title5:'其中:享受无形资产加速摊销及一次性摊销政策的资产加速摊销额大于一般摊销额的部分',
				title4:'三、无形资产(合计)',
				title3:'二、生产性生物资产',
				title2:'一、资产固定（合计）',
				title1:'其中:享受固定资产加速折旧及一次性扣除政策的资产加速折旧额大于一般折旧额的部分受固定资产加速折旧及一次性扣除政策的资产加速折旧额大于一般折旧额的部分',
				showbox:{
					cqgqtz:false,
					zgfl:false,
					ghjf:false,
					bcylbx:false,
					bcyilbx:false,
				},
				cycle:[
					{
						value:"1",
						label:'按年'
					},
					{
						value:"2",
						label:'按季'
					},
					{
						value:"3",
						label:'按月'
					}
				],
				userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
			}
		},
		created() {
			this.searchlist[0].selectval=this.searchlist[0].selectval.filter(item=>item.label!=this.userInfo.deptName)
			this.searchlist[0].selectval.unshift({
				label:this.userInfo.deptName,
				value:this.userInfo.deptName
			})
			let arr=JSON.parse(JSON.stringify(this.searchlist))
			this.searchlist=arr
			this.searchdata.nsrmc=this.userInfo.deptName
			this.tableData=this.$getZcBankStorage('zczjtxtabledata')||getdata().tableData
		},
		mounted() {
		
		},
		methods: {	  geOoverLength(e){
		  this.overlength = e;
		 
	  },
			spanmethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(row.project==this.title2){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
						
				}
				if(row.project==this.title3){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
						
				}
				if(row.project==this.title4){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				
				if(row.project==this.title6){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				if(row.project==this.title7){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				if(row.project==this.title8){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				if(row.project==this.title9){
					if(columnIndex==0){
						return {
							rowspan: 0,
							colspan: 0
						};
					}else if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 2
						};
					}
				}
				if(row.project==this.title1){
					 if(columnIndex==1){
						return {
							rowspan: 1,
							colspan:18
						};
					}else if(columnIndex==18){
						return {
							rowspan: 1,
							colspan: 1
						};
					}else{
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
				if(row.project==this.title5){
					 if(columnIndex==1){
						return {
							rowspan: 1,
							colspan: 18
						};
					}else if(columnIndex==18){
						return {
							rowspan: 1,
							colspan: 1
						};
					}else{
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},
			//文件导入
			file_import(){
				this.filediag = true
				this.upformdata = {
				  upfilename: "",
				  upfile: "",
				  filestate: "",
				  filetype: "",
				  filesize: "",
				}
			},
			//获取上传文件流
			getuploadparams(){
				this.upformdata = e;
			},
			//下载标准模板
			fordownloadmb(){
				
			},
			//确认上传文件
			forupload(){
				
			},
			//编辑保存
			preservation(e){
				e.updata = false
				let arr = ['SelfSOV','AmountA','DepreciationY','AccumulatedD','AssetTax','TaxDepreciation','acceleratedDP','AcceleratedD','AccumulatedDe','TaxAA']
				let obj = {SelfSOV:0,AmountA:0,DepreciationY:0,AccumulatedD:0,AssetTax:0,TaxDepreciation:0,acceleratedDP:0,AcceleratedD:0,AccumulatedDe:0,TaxAA:0,}
				let obj1 = {SelfSOV:0,AmountA:0,DepreciationY:0,AccumulatedD:0,AssetTax:0,TaxDepreciation:0,acceleratedDP:0,AcceleratedD:0,AccumulatedDe:0,TaxAA:0,}
				
				this.tableData.map(item=>{
					if(e.obj==item.obj){
						arr.map(item1=>{
							obj[item1] =  Number(obj[item1]) + Number(item[item1]) 
						})
					}
				})
				this.tableData.map(item=>{
					if(e.obj==item.project&&item.projectT){
						arr.map(item1=>{
							item[item1] = this.toFixed(obj[item1],2) 
						})
					}
					if(item.projectT&&!item.heji){
						arr.map(item1=>{
							obj1[item1] =  Number(obj1[item1]) + Number(item[item1]) 
						})
					}
				})
				this.tableData.map(item=>{
					if(item.heji){
						arr.map(item1=>{
							item[item1] = this.toFixed(obj1[item1],2) 
						})
					}
				})
				this.$setZcBankStorage('zczjtxtabledata',this.tableData)
				this.$message.success('操作成功')
			},
			//返回
			forback(e){
				Object.keys(this.showbox).map(key=>{
					if(this.showbox[key]){
						this.showbox[key] = false
					}
				})
			},
			//点击明细
			detailed(e){
				Object.keys(this.showbox).map(key=>{
					if(key==e.sbbm){
						this.showbox[key] = true
					}
				})
			},
			//编辑
			editOpen(e){
				for(let a = 0 ; a < this.tableData.length ; a ++){
					if(this.tableData[a].updata){
						return this.$message.error('存在未保存（取消）的数据，请保存（取消）后再编辑')
					}
				}
				this.updataItem = JSON.parse(JSON.stringify(e))
				e.updata = true
			},
			canceOpen(index){
				this.tableData[index]=JSON.parse(JSON.stringify(this.updataItem))
				this.tableData[index].updata = false
				let newarr=JSON.parse(JSON.stringify(this.tableData))
				this.tableData=newarr
				
			},
			//删除行/添加行
			addRows(e,item){
				let num = e+1
				if(item.project!='全民所有制企业公司制改制资产评估增值政策资产'){
					let obj = null
					for(let a = 0 ; a < this.tableData.length ; a++){
						if(this.tableData[a].projectT&&a==num-1){
							obj=this.tableData[a].project
							break 
						}else if(a==num-1&&!this.tableData[a].projectT){
							obj=this.tableData[a].obj
							break	
						}
					}
					this.tableData.splice(num,0,{
						obj,
						Serial:1,
						ProjectD:'',
						cycle:null,
						shuikssqq:null,
						shuikssqz:null,
						SelfSOV:0,
						AmountA:0,
						DepreciationY:0,
						AccumulatedD:0,
						AssetTax:0,
						TaxDepreciation:0,
						acceleratedDP:0,
						AcceleratedD:0,
						AccumulatedDe:0,
						TaxAA:0,
						prop1:'',
						prop2:'',
						prop3:'',
						updata:false,
					})
					let one = 0
					let two = 0
					for(let a = num ; a >= 0 ; a--){
						if(!this.tableData[a].projectT){
							 one++
						}else{
							break
						}
					}
					for(let a = num ; a < this.tableData.length ; a++){
						if(!this.tableData[a].projectT){
							 two++
						}else{
							break
						}
					}
					for(let a = num ; a < this.tableData.length ; a++){
						if(!this.tableData[a].projectT&&a<(num+two)&&!this.tableData[a].fulie){
							this.tableData[a].Serial = a-num+one
						}
					}
				}else{
					this.tableData.splice(num,0,{
						project: '全民所有制企业公司制改制资产评估增值政策资产',
						Serial:'附列资料',
						ProjectD:'',
						cycle:'',
						shuikssqq:'',
						shuikssqz:'',
						AmountC:'',
						TaxAmount:'',
						IncreaseA:'',
						DecreaseA:'',
						prop1:'',
						prop2:'',
						prop3:'',
						updata:false,
					})
				}
				this.tableData[num].select = this.tableData[e].select
				this.tableData[num].option = this[this.tableData[e].select]
				this.$setZcBankStorage('zczjtxtabledata',this.tableData)
				this.$message.success('操作成功')
			},
			DeleteRows(e){
				this.tableData.splice(e,1)
				let num = e
				let one = 0 
				let two = 0 
				for(let a = num ; a >= 0 ; a--){
					if(!this.tableData[a].projectT){
						 one++
					}else{
						break
					}
				}
				for(let a = num ; a < this.tableData.length ; a++){
					if(!this.tableData[a].projectT){
						 two++
					}else{
						break
					}
				}
				for(let a = num ; a < this.tableData.length ; a++){
					if(!this.tableData[a].projectT&&a<(num+two)&&!this.tableData[a].fulie){
						this.tableData[a].Serial = a-num+one
					}
				}
				this.$setZcBankStorage('zczjtxtabledata',this.tableData)
				this.$message.success('操作成功')
			},
			//搜索
			submitSearch(){
				this.tableData=this.$getZcBankStorage('zczjtxtabledata')||getdata().tableData
				this.$emptyandnull(this.searchdata.year)?this.searchdata.year="2023":''
				this.$emptyandnull(this.searchdata.nsrmc)?this.searchdata.nsrmc=this.userInfo.deptName:''
				this.searchdata.year!="2023"||this.searchdata.nsrmc!=this.userInfo.deptName?this.tableData=[]:''
				for (let key in this.searchdata) {
					if(this.$notemptyandnull(this.searchdata[key])&&key!="year"&&key!="nsrmc"){
						 if(key=='shuikssq'){
						 	this.tableData=this.tableData.filter(item=>item.shuikssqq>=this.searchdata.shuikssq[0]&&item.shuikssqz<=this.searchdata.shuikssq[1])
							if(this.tableData.length==0){
								this.tableData = JSON.parse(JSON.stringify(getdata().tableData))
							}else{
								let tabledata =  JSON.parse(JSON.stringify(getdata().tableData))
								tabledata.map((item,index)=>{
									this.tableData.map(item1=>{
										if(item.project==item1.obj){
											tabledata.splice((index+1),0,item1)
										}
									})
								})
								this.tableData = tabledata
							}
						 }else{
							 this.tableData=this.tableData.filter(item=>this.$notemptyandnull(item[key])&&item[key]==this.searchdata[key])
							if(this.tableData.length==0){
								this.tableData = JSON.parse(JSON.stringify(getdata().tableData))
							}else{
								let tabledata =  JSON.parse(JSON.stringify(getdata().tableData))
								tabledata.map((item,index)=>{
									this.tableData.map(item1=>{
										if(item.project==item1.obj){
											tabledata.splice((index+1),0,item1)
										}
									})
								})
								this.tableData = tabledata
							}
						 }
					}
				}
			},
			//分页
			sizechange(e) {
			  this.pagination.pageSize = e;
			},
			currentChange(e) {
			  this.pagination.pageNum = e;
			},
			confirmfilter(e) {
			  this.headData = e.chooselist;
			  this.outlist = e.nochooselist;
			  this.shaidiag = false;
			},
			closeshaidiag() {
			  this.shaidiag = false;
			},
		}
	};
</script>

<style scoped lang="less">
	@import url('index.less');
</style>
